export const removeVietnameseTones = (str: string) =>
    (str ?? '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D');

export const getItems = (props: any): any[] => {
    const ds = props.dataSource ?? props.items ?? [];
    if (Array.isArray(ds)) return ds;
    // Custom DataSource / ArrayStore
    if (ds && typeof ds.items === 'function') return ds.items();
    if (ds && typeof ds._store?._array !== 'undefined') return ds._store._array;
    return [];
};

export const getField = (item: any, expr?: string | ((x: any) => any)) => {
    if (item === null || item === undefined) return undefined;
    if (!expr) return item;
    if (typeof expr === 'function') return expr(item);
    return item[expr];
};